import { Box } from '@mui/material'
import { COLORS } from 'styles/colors'
import { TypographyHeader14 } from 'ui/typography/TypographyHeader14'

interface ICounterSpanProps {
	active: boolean
	count: number
}

export const CounterSpan = ({ active, count }: ICounterSpanProps) => {
	const isLong = count >= 10

	return (
		<Box
			component='span'
			sx={{
				borderRadius: isLong ? '12px' : '50%',
				minWidth: '18px',
				height: '18px',
				padding: '0 4px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				backgroundColor: active ? '#fff' : COLORS.health,
				textAlign: 'center',
				position: 'absolute',
				bottom: '4px',
				right: '4px',
			}}
		>
			<TypographyHeader14 sx={{ color: active ? COLORS.health : '#fff' }}>
				{count}
			</TypographyHeader14>
		</Box>
	)
}
